import { render, staticRenderFns } from "./QuizUploadFile.vue?vue&type=template&id=17e35faf&"
import script from "./QuizUploadFile.vue?vue&type=script&lang=ts&"
export * from "./QuizUploadFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports